<template>
  <div class="page-container">
    <div class="msg-head">
      <el-tabs v-model="tab" @tab-click="loadData">
        <el-tab-pane label="全部" name="all" />
        <el-tab-pane label="告警" name="告警" />
        <el-tab-pane label="系统" name="系统" />
        <el-tab-pane label="工单" name="工单" />
      </el-tabs>
      <div class="msg-actions">
        <el-badge :value="unread" :hidden="!unread" class="badge">
          <span class="unread-text">未读 {{ unread }}</span>
        </el-badge>
        <el-button v-if="hasPermission('message_read')" type="primary" plain icon="el-icon-check" :disabled="!unread" @click="readAll">全部已读</el-button>
      </div>
    </div>

    <div class="msg-list">
      <div
        v-for="m in list"
        :key="m.id"
        class="msg-item"
        :class="{ unread: m.read === 0 }"
        @click="openMsg(m)"
      >
        <div class="msg-dot" :style="{ background: typeColor(m.type) }"></div>
        <div class="msg-main">
          <div class="msg-title">
            <span>{{ m.title }}</span>
            <el-tag size="mini" effect="plain" :style="{ color: typeColor(m.type), borderColor: typeColor(m.type) }">{{ m.type }}</el-tag>
            <span class="msg-time">{{ m.time }}</span>
          </div>
          <div class="msg-content">{{ m.content }}</div>
        </div>
        <el-link v-if="m.read === 0 && hasPermission('message_read')" type="primary" @click.stop="readOne(m)">标记已读</el-link>
      </div>
      <el-empty v-if="!list.length" description="暂无消息" />
    </div>
  </div>
</template>

<script>
import { getMessages, readMessage, readAllMessages } from '@/api/sentinel'

export default {
  name: 'MessageIndex',
  data() {
    return {
      tab: 'all',
      list: [],
      unread: 0,
      loading: false
    }
  },
  mounted() { this.loadData() },
  methods: {
    hasPermission(k) { return this.$store.getters.hasPermission(k) },
    typeColor(t) { return { '告警': '#f53f3f', '系统': '#165dff', '工单': '#ff7d00' }[t] || '#86909c' },
    loadData() {
      this.loading = true
      const params = this.tab === 'all' ? {} : { type: this.tab }
      getMessages(params).then(res => {
        if (res.code === 200) {
          this.list = (res.data && res.data.list) || []
          this.unread = (res.data && res.data.unread) || 0
        }
      }).finally(() => { this.loading = false })
    },
    openMsg(m) {
      if (m.read === 0) this.readOne(m)
    },
    readOne(m) {
      readMessage(m.id).then(res => {
        if (res.code === 200) { m.read = 1; this.unread = Math.max(0, this.unread - 1) }
      })
    },
    readAll() {
      readAllMessages().then(res => {
        if (res.code === 200) { this.list.forEach(m => { m.read = 1 }); this.unread = 0; this.$message.success('已全部标记为已读') }
      })
    }
  }
}
</script>

<style scoped>
.msg-head { display: flex; align-items: center; justify-content: space-between; background: #fff; border-radius: 4px; padding: 0 16px; box-shadow: 0 2px 12px rgba(0,0,0,.1); }
.msg-head .el-tabs { flex: 1; }
.msg-actions { display: flex; align-items: center; gap: 14px; }
.unread-text { font-size: 13px; color: #86909c; }
.badge { margin-top: 4px; }
.msg-list { margin-top: 16px; background: #fff; border-radius: 4px; box-shadow: 0 2px 12px rgba(0,0,0,.1); padding: 8px 16px; }
.msg-item { display: flex; align-items: center; gap: 14px; padding: 14px 8px; border-bottom: 1px solid #f2f3f5; cursor: pointer; }
.msg-item:last-child { border-bottom: none; }
.msg-item.unread { background: #f7f8fa; }
.msg-dot { width: 8px; height: 8px; border-radius: 50%; flex-shrink: 0; }
.msg-main { flex: 1; min-width: 0; }
.msg-title { display: flex; align-items: center; gap: 10px; font-size: 14px; font-weight: 600; color: #1d2129; }
.msg-time { margin-left: auto; font-size: 12px; color: #86909c; font-weight: 400; }
.msg-content { font-size: 13px; color: #4e5969; margin-top: 4px; }
</style>
